import React from "react";
import { Link } from "react-router-dom";
import "./Forum.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

interface Props {}

const Forum = (props: Props) => {
  return (
    <section className="forum">
      <Container className="forum-headding">
        <h1>Forum</h1>
      </Container>
      <Container>
        <hr></hr>
        <Nav className="me-auto">
          <Nav.Link href="/Forum">All</Nav.Link>
          <Nav.Link href="/Forum">New</Nav.Link>
          <Nav.Link href="/Forum">My posts</Nav.Link>
          <Nav.Link href="/Forum">Read</Nav.Link>
        </Nav>
      </Container>
      <Container className="table-headdings">
        <Row className="justify-content-md-center">
          <Col>tests</Col>
          <Col className="p-0">tests</Col>
          <Col className="p-0">tests</Col>
        </Row>
      </Container>
    </section>
  );
};

export default Forum;
